/**
 * Type for animations props.
 *
 * @remarks
 * String for 'ul'
 * Object for `DefineComponent` type
 * Function for `() => NoElement`
 *
 * @public
 */
export const AnimationProp = [String, Object, Function]
